<template>
  <div>
      <div id="CasosCards" class="row topCardGrid">
          <sp-card :valor="cardCasosConfirmados" :descricao="$t('covid.casosConfirmadosg')"
            :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})"/>
          <sp-card :valor="cardObitosConfirmados" :descricao="$t('covid.obitosConfirmados')"
            :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})"/>
          <sp-card :valor="cardCasosSuspeitos" :descricao="$t('covid.casosSuspeitos')"
            :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})"/>
          <sp-card :valor="cardObitosSuspeitos" :descricao="$t('covid.obitosSuspeitos')"
            :footerText="$t('rodape.estimativa', {fonte: cards.metadados.fonte, data: cards.metadados.data})"/>
      </div>
      <div id="CasosAtivos" class="row">
        <div class="flex col md12 lg12">
        <sp-360-panel id="graficoDeObitosPorDiaMaisAcumulados" class="chart-widget" :title="$t('covid.tituloCasos')"
          :footerText="$t('rodape.fonteData', {fonte: chartCasosConfirmados.metadados.fonte, data: chartCasosConfirmados.metadados.data})">
          <div class="toggles">
            <va-button-toggle
              id="toggle-button"
              outline
              v-model="model"
              :options="toggleButtonOptionsCasos"
              color="info"
              @input="onToggleChangeCasos"
            />

            <va-button-toggle
              id="toggle-button"
              outline
              v-model="modelEscala"
              :options="toggleButtonOptionsEscalaCasos"
              color="dark"
              @input="onChanceEscalaCasos"
            />
          </div>

          <sp360-chart ref="chartCasosConfirmados" id="grafico" :type="tipoGraficoCasos" :data="chartCasosConfirmados.data" :options="chartCasosConfirmados.options" />

        </sp-360-panel>
        </div>
      </div>

      <div id="Obitos" class="row">
        <div class="flex col md12 lg12">
        <sp-360-panel  id="graficoDeObitosPorDiaMaisAcumulados" class="chart-widget" :title="$t('covid.tituloObitos')"
          :footerText="$t('rodape.fonteData', {fonte: chartObitosConfirmados.metadados.fonte, data: chartObitosConfirmados.metadados.data})">
          <div class="toggles">
            <va-button-toggle
              id="toggle-button"
              outline
              v-model="modelObitos"
              :options="toggleButtonOptionsObitos"
              color="info"
              @input="onToggleChangeObitos"
            />
            <va-button-toggle
              id="toggle-button"
              outline
              v-model="modelEscalaObitos"
              :options="toggleButtonOptionsEscalaObitos"
              color="dark"
              @input="onChanceEscalaObitos"
            />
          </div>
          <sp360-chart ref="chartObitosConfirmados" id="grafico" :type="tipoGraficoObitos" :data="chartObitosConfirmados.data" :options="chartObitosConfirmados.options" />
        </sp-360-panel>
        </div>
      </div>

      <!-- <div id="Isolamento" class="row">
        <div class="flex col md12 lg12">
        <sp-360-panel id="GrafLinhaIsolamentoComThreshold" class="chart-widget" :title="$t('covid.isolamentoSocial')">
            <sp-360-chart />
        </sp-360-panel>
        </div>
      </div> -->
      <div id="TimeLine" class="row">
        <div class="flex col md12 lg12 ">
        <sp-360-panel id="timelineAmchartsEnfrentamentoeControle" class="chart-widget" :title="$t('covid.controleEEnfrentamento')"
            :footerText="$t('rodape.fonteData', {fonte: chartAcoes.metadados.fonte, data: chartAcoes.metadados.data})">
          <va-timeline vertical centered>

            <va-timeline-item v-for="(m, index) in data" :key="index" active >
              <span
                id="timelineSpan"
                slot="before"
                class="title va-timeline-item__text"
               :style="{color: $themes.primary}"
              >
              {{ m.dia }}
              </span>
              <va-card
                slot="after"
                :stripe="tema(m) || 'success'"
                class="mb-0"
              >
              <template slot="title">{{ m.tema }}</template>
              {{ m.acao }}
              </va-card>
            </va-timeline-item>

          </va-timeline>

        <sp-360-chart />
        </sp-360-panel>
        </div>
      </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import DreMap from '@/components/maps/360-maps/DREMap'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

import lastUpdate from '@/utils/LastUpdate'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

export default {
  /*
     Casos Suspeitos Acumulado
     Casos Confirmados Acumulado
     Casos Mundo Acumulado
     Casos Brasil Acumulado
     Casos Estado de SP Acumulado
     Casos Confirmados Diarios
     Óbitos Confirmados Acumulado
     Óbitos Suspeitos Acumulado
     Obitos Confirmados Diarios SFMSP
     Obitos Suspeitos Diarios SFMSP
     Obitos Geral Diarios SFMSP
     Obitos Confirmados Acumulado SFMSP
     Obitos Suspeitos Acumulado SFMSP
  */
  components: {
    SpCard,
    Sp360Panel,
    Sp360Chart,
  },

  data () {
    return {
      cards: {
        metadados: {
          fonte: '',
          data: '',
        },
      },
      casosConfirmados: 0,
      obitosConfirmados: 0,
      casosSuspeitos: 0,
      obitosSuspeitos: 0,
      chartAcoes: {
        metadados: {
          fonte: '',
          data: '',
        },
      },
      data: [
        {
          dia: ' ',
          acao: ' ',
          tema: ' ',
        },
        {
          dia: ' ',
          acao: ' ',
          tema: ' ',
        },
        {
          dia: ' ',
          acao: ' ',
          tema: ' ',
        },
        {
          dia: ' ',
          acao: ' ',
          tema: ' ',
        },
        {
          dia: ' ',
          acao: ' ',
          tema: ' ',
        },
        {
          dia: ' ',
          acao: ' ',
          tema: ' ',
        },
        {
          dia: ' ',
          acao: ' ',
          tema: ' ',
        },
      ],
      dataTotal: [],

      dadosAcoes: [],

      chartCasosConfirmados: {
        data: {},
        options: [],
        metadados: {
          fonte: '',
          data: '',
        },
      },

      chartObitosConfirmados: {
        data: {},
        options: [],
        metadados: {
          fonte: '',
          data: '',
        },
      },

      toggleButtonOptionsCasos: [
        { label: 'Diário', value: 'diario' },
        { label: 'Acumulado', value: 'acumulado' },
      ],
      toggleButtonOptionsObitos: [
        { label: 'Diário', value: 'diario' },
        { label: 'Acumulado', value: 'acumulado' },
      ],
      toggleButtonOptionsEscalaCasos: [
        { label: 'Linear', value: 'linear' },
        { label: 'Logarítmica', value: 'logarithmic' },
      ],
      toggleButtonOptionsEscalaObitos: [
        { label: 'Linear', value: 'linear' },
        { label: 'Logarítmica', value: 'logarithmic' },
      ],

      model: 'acumulado',
      modelObitos: 'acumulado',
      modelEscala: 'linear',
      modelEscalaObitos: 'linear',

      tipoSelecionadaCasos: 'acumulado',
      tipoSelecionadaObitos: 'acumulado',

      escalaSelecionadaCasos: 'linear',
      escalaSelecionadaObitos: 'linear',

    }
  },

  computed: {

    tipoGraficoCasos () { return this.tipoSelecionadaCasos === 'diario' ? 'vertical-bar' : 'line' },
    tipoGraficoObitos () { return this.tipoSelecionadaObitos === 'diario' ? 'vertical-bar' : 'line' },

    cardCasosConfirmados () { return this.casosConfirmados ? MethGlob.formatarGrandesNumeros(this.casosConfirmados) : 0 },
    cardObitosConfirmados () { return this.obitosConfirmados ? MethGlob.formatarGrandesNumeros(this.obitosConfirmados) : 0 },

    cardCasosSuspeitos () { return this.casosSuspeitos ? MethGlob.formatarGrandesNumeros(this.casosSuspeitos) : 0 },
    cardObitosSuspeitos () { return this.obitosSuspeitos ? MethGlob.formatarGrandesNumeros(this.obitosSuspeitos) : 0 },
  },
  beforeMount () {
    Promise.all([
      this.$store.dispatch('covid/buscarAcoesPMSP', { inicio: '' }),
      this.$store.dispatch('covid/buscarCasosObitos', { inicio: '' }),
      this.$store.dispatch('covid/buscarCasosObitosConsolidados', { inicio: '' }),
      this.$store.dispatch('covid/buscarCasosObitosAcumulado', { inicio: '' }),
      this.$store.dispatch('covid/buscarIsolamentoSocial', { inicio: '' }),
    ]).then((response) => {
      this.fonte = response[1].data.sigla_orgao + '-' + response[1].data.fonte
      this.dataRef = new Date(response[1].data.data_referencia_dado).toDateString('pt-BR')
      this.footerText = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

      this.dataTotal = response[0].data.data
      this.dadosCasosConfirmados = response[1].data.data
      this.getInitialUsers()

      this.chartAcoes.metadados.fonte = response[0].data.sigla_orgao
      this.chartAcoes.metadados.data = MethGlob.dataParaMesExtensoAno(response[0].data.data_referencia_dado)
      this.dadosAcoes = _.groupBy(response[0].data.data, 'dia')
      this.casosConfirmados = response[2].data.data[0]['casos_confirmados']
      this.obitosConfirmados = response[2].data.data[0]['obitos_confirmados']
      this.casosSuspeitos = response[2].data.data[0]['casos_suspeitos']
      this.obitosSuspeitos = response[2].data.data[0]['obitos_suspeitos']

      this.cards.metadados.fonte = response[2].data.sigla_orgao
      this.cards.metadados.data = MethGlob.dataParaMesExtensoAno(response[2].data.data_referencia_dado)

      this.chartCasosConfirmados.metadados.fonte = response[1].data.sigla_orgao
      this.chartCasosConfirmados.metadados.data = MethGlob.dataParaMesExtensoAno(response[1].data.data_referencia_dado)
      this.chartCasosConfirmados.data = this.populateCasosConfirmadosDiario(response[1].data.data, 'casos_confirmados', true)
      this.chartCasosConfirmados.options = this.getLineChartOptions('Data', 'Número de Casos Confirmados', 'linear')

      this.chartObitosConfirmados.metadados.fonte = response[1].data.sigla_orgao
      this.chartObitosConfirmados.metadados.data = MethGlob.dataParaMesExtensoAno(response[1].data.data_referencia_dado)
      this.chartObitosConfirmados.data = this.populateCasosConfirmadosDiario(response[1].data.data, 'obitos_confirmados', true)
      this.chartObitosConfirmados.options = this.getLineChartOptions('Data', 'Número de Obitos Confirmados', 'linear')
    })
  },
  mounted () {
    this.scroll()
  },
  methods: {
    tema (m) {
      return 'success'
      return m.cor == 'verde' ? 'success' : 'danger'
    },

    onToggleChangeCasos (event) {
      this.tipoSelecionadaCasos = event
      let data = []

      if (event === 'acumulado') { data = this.populateCasosConfirmadosDiario(this.dadosCasosConfirmados, 'casos_confirmados', true) } else { data = this.populateCasosConfirmadosDiario(this.dadosCasosConfirmados, 'casos_confirmados') }

      let options = this.getLineChartOptions('Data', 'Número de Casos Confirmados', this.escalaSelecionadaCasos)
      this.$set(this.chartCasosConfirmados, 'data', data)
      this.$set(this.chartCasosConfirmados, 'options', options)
      this.$refs.chartCasosConfirmados.$refs.chart.renderChart(data, options)
    },
    onToggleChangeObitos (event) {
      this.tipoSelecionadaObitos = event
      let data = []

      if (event === 'acumulado') { data = this.populateCasosConfirmadosDiario(this.dadosCasosConfirmados, 'obitos_confirmados', true) } else { data = this.populateCasosConfirmadosDiario(this.dadosCasosConfirmados, 'obitos_confirmados') }

      let options = this.getLineChartOptions('Data', 'Número de Obitos Confirmados', this.escalaSelecionadaObitos)
      this.$refs.chartObitosConfirmados.$refs.chart.renderChart(data, options)
      this.$set(this.chartObitosConfirmados, 'data', data)
      this.$set(this.chartObitosConfirmados, 'options', options)
    },

    onChanceEscalaCasos (event) {
      this.escalaSelecionadaCasos = event
      let data = []
      if (this.tipoSelecionadaCasos === 'acumulado') { data = this.populateCasosConfirmadosDiario(this.dadosCasosConfirmados, 'casos_confirmados', true) } else { data = this.populateCasosConfirmadosDiario(this.dadosCasosConfirmados, 'casos_confirmados') }

      let options = this.getLineChartOptions('Data', 'Número de Casos Confirmados', event)

      this.$set(this.chartCasosConfirmados, 'data', data)
      this.$set(this.chartCasosConfirmados, 'options', options)
      this.$refs.chartCasosConfirmados.$refs.chart.renderChart(data, options)
    },

    onChanceEscalaObitos (event) {
      this.escalaSelecionadaObitos = event
      let data = []
      if (this.tipoSelecionadaObitos === 'acumulado') { data = this.populateCasosConfirmadosDiario(this.dadosCasosConfirmados, 'obitos_confirmados', true) } else { data = this.populateCasosConfirmadosDiario(this.dadosCasosConfirmados, 'obitos_confirmados') }

      let options = this.getLineChartOptions('Data', 'Número de Obitos Confirmados', this.escalaSelecionadaObitos)

      this.$set(this.chartObitosConfirmados, 'data', data)
      this.$set(this.chartObitosConfirmados, 'options', options)
      this.$refs.chartObitosConfirmados.$refs.chart.renderChart(data, options)
    },

    scroll () {
      window.onscroll = () => {
        let bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) - document.documentElement.offsetHeight < 0.1

        if (bottomOfWindow && this.dataTotal.length) {
          let u = this.dataTotal.pop()
          setTimeout(() => {
            this.data.push(u)
          }, 900)
        }
      }
    },

    getInitialUsers () {
      for (var i = 0; i <= 6; i++) {
        this.data[i] = this.dataTotal.pop()
      }
    },

    getLineChartOptions (legendaX, legendaY, tipo, tooltipCustomizado = false, percentual = true, milhar = false) {
      return {
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            title: (tooltipItem, chart) => {
              return tooltipItem[0].xLabel
              let label = chart.datasets[0].label + '  ' || ''
              label += tooltipItem[0].yLabel

              return label + ' \nAção do dia ' + tooltipItem[0].xLabel + ': '
            },
            label: (tooltipItem, chart) => {
              let label = chart.datasets[0].label + '  ' || ''
              label += tooltipItem.yLabel + ' '

              return label

              var tooltipEl = document.getElementById('chartjs-tooltip')
              return this.dadosAcoes[tooltipItem.xLabel] ? this.dadosAcoes[tooltipItem.xLabel][0]['acao'] : 'Nenhuma ação registrada.'
            },
          },

          custom: function (tooltipModel) {
            // Tooltip Element
            return
            if (this._chart.config.type == 'bar') return
            let tooltipEl = document.getElementById('chartjs-tooltip')

            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement('div')
              tooltipEl.id = 'chartjs-tooltip'
              tooltipEl.innerHTML = '<table style="background-color: rgb(0,0,0, .8); border-radius: 2px; color: white; "></table>'
              document.body.appendChild(tooltipEl)
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform')
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign)
            } else {
              tooltipEl.classList.add('no-transform')
            }

            // Set Text
            if (tooltipModel.body) {
              let titleLines = tooltipModel.title || []
              let bodyLines = tooltipModel.body.map((bodyItem) => { return bodyItem.lines })

              let innerHtml = '<thead>'

              titleLines.forEach(function (title) {
                innerHtml += '<tr><th>' + title + '</th></tr>'
              })
              innerHtml += '</thead><tbody>'

              bodyLines.forEach(function (body, i) {
                let colors = tooltipModel.labelColors[i]
                let style = 'background:' + colors.backgroundColor
                style += '; border-color:' + colors.borderColor
                style += '; border-width: 2px'
                let span = '<span style="' + style + '"></span>'
                innerHtml += '<tr><td style="padding: 5px" >' + span + body + '</td></tr>'
              })
              innerHtml += '</tbody>'

              let tableRoot = tooltipEl.querySelector('table')
              tableRoot.innerHTML = innerHtml
            }

            // `this` will be the overall tooltip
            let position = this._chart.canvas.getBoundingClientRect()

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1
            tooltipEl.style.position = 'absolute'

            if (tooltipModel.caretX - tooltipModel.caretY < position.bottom) {
              tooltipEl.style.left = position.left - position.left * 0.1 + tooltipModel.caretX + 'px'
              tooltipEl.style.top = position.top - position.bottom * 0.2 + tooltipModel.caretY + 'px'
            } else {
              tooltipEl.style.left = position.left - position.left + tooltipModel.caretX + 'px'
              tooltipEl.style.top = position.top - position.bottom * 0.001 + tooltipModel.caretY + 'px'
            }

            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
            tooltipEl.style.padding = tooltipModel.yPadding * 10 + 'px ' + tooltipModel.xPadding * 10 + 'px'
            tooltipEl.style.pointerEvents = 'none'
          },

        },
        maintainAspectRatio: false,
        aspectRatio: 4,
        responsive: true,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        elements: {
          point: {
            // backgroundColor:(tooltipItem, ctx) => {
            //   let dia = tooltipItem.chart.tooltip._data.labels[tooltipItem.dataIndex]
            //   if(this.dadosAcoes[dia] )
            //     return 'red'
            //   else
            //     return 'green'

            // },
            // hoverBackgroundColor: makeHalfAsOpaque,
            // radius: adjustRadiusBasedOnData,
            pointStyle: (tooltipItem, ctx) => {
              return 'circle'

              let dia = tooltipItem.chart.tooltip._data.labels[tooltipItem.dataIndex]
              if (this.dadosAcoes[dia]) { return 'rect' } else { return 'circle' }
            },
            hoverRadius: 15,
          },
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 15,
              callback: (value) => MethGlob.thousandSeparator(value),
            },
            id: 'y-axis-1',
            type: tipo || 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          }],
        },
        plugins: {
          datalabels: {
            clamp: true,
            font: {
              size: 16,
              weight: 'bold',
            },
            anchor: 'start',
            align: 'end',
            color: '#000',
            display: true,
          },
        },
      }
    },

    populateCasosConfirmadosDiario (dados, campo, acumulado) {
      let chartData = { labels: [], datasets: [] }
      let escala = campo == 'casos_confirmados' ? this.escalaSelecionadaCasos : this.escalaSelecionadaObitos
      let cor = escala == 'linear' ? CorUtils.getCorPorNomeSp360('azul-claro') : CorUtils.getCorPorNomeSp360('azul-escuro')
      let dataset = {
        data: [],
        label: 'Número de ' + campo.replace('_', ' '),
        backgroundColor: cor,
        borderColor: cor,
        fill: false,
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => value.toLocaleString('pt-BR'),
          display: false,
          anchor: 'start',
          rotation: -90,
          align: 'end',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }

      let totalAcumulado = 0

      for (let e in dados) {
        if (acumulado) {
          totalAcumulado += dados[e][campo]
          dataset.data.push(totalAcumulado)
        } else {
          dataset.data.push(dados[e][campo])
        }
        let d = new Date(dados[e]['dia'])
        chartData.labels.push(dados[e]['dia'])
      }

      chartData.datasets.push(dataset)

      return chartData
    },

    montarTimeline () {
      /* Chart code */
      // Themes begin
      am4core.useTheme(am4themes_animated)
      // Themes end

      am4core.ready(function () {
        let chart = am4core.create('chartdiv', am4plugins_timeline.CurveChart)
        chart.curveContainer.padding(100, 20, 50, 20)
        chart.maskBullets = false

        let colorSet = new am4core.ColorSet()

        chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd HH:mm'
        chart.dateFormatter.dateFormat = 'HH'

        chart.fontSize = 10
        chart.tooltipContainer.fontSize = 10

        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis())
        categoryAxis.dataFields.category = 'category'
        categoryAxis.renderer.grid.template.disabled = true
        categoryAxis.renderer.labels.template.paddingRight = 25
        categoryAxis.renderer.minGridDistance = 10
        categoryAxis.renderer.innerRadius = 10
        categoryAxis.renderer.radius = 30

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis())

        dateAxis.renderer.points = this.getPoints()

        dateAxis.renderer.autoScale = false
        dateAxis.renderer.autoCenter = false
        dateAxis.renderer.minGridDistance = 70
        dateAxis.baseInterval = { count: 5, timeUnit: 'minute' }
        dateAxis.renderer.tooltipLocation = 0
        dateAxis.renderer.line.strokeDasharray = '1,4'
        dateAxis.renderer.line.strokeOpacity = 0.5
        dateAxis.tooltip.background.fillOpacity = 0.2
        dateAxis.tooltip.background.cornerRadius = 5
        dateAxis.tooltip.label.fill = new am4core.InterfaceColorSet().getFor('alternativeBackground')
        dateAxis.tooltip.label.paddingTop = 7
        dateAxis.endLocation = 0
        dateAxis.startLocation = -0.5
        dateAxis.min = new Date(2019, 0, 9, 23, 55).getTime()
        dateAxis.max = new Date(2019, 0, 11, 7, 10).getTime()

        let labelTemplate = dateAxis.renderer.labels.template
        labelTemplate.verticalCenter = 'middle'
        labelTemplate.fillOpacity = 0.6
        labelTemplate.background.fill = new am4core.InterfaceColorSet().getFor('background')
        labelTemplate.background.fillOpacity = 1
        labelTemplate.fill = new am4core.InterfaceColorSet().getFor('text')
        labelTemplate.padding(7, 7, 7, 7)

        let series = chart.series.push(new am4plugins_timeline.CurveColumnSeries())
        series.columns.template.height = am4core.percent(30)

        series.dataFields.openDateX = 'start'
        series.dataFields.dateX = 'end'
        series.dataFields.categoryY = 'category'
        series.baseAxis = categoryAxis
        series.columns.template.propertyFields.fill = 'color' // get color from data
        series.columns.template.propertyFields.stroke = 'color'
        series.columns.template.strokeOpacity = 0
        series.columns.template.fillOpacity = 0.6

        let imageBullet1 = series.bullets.push(new am4plugins_bullets.PinBullet())
        imageBullet1.background.radius = 18
        imageBullet1.locationX = 1
        imageBullet1.propertyFields.stroke = 'color'
        imageBullet1.background.propertyFields.fill = 'color'
        imageBullet1.image = new am4core.Image()
        imageBullet1.image.propertyFields.href = 'icon'
        imageBullet1.image.scale = 0.7
        imageBullet1.circle.radius = am4core.percent(100)
        imageBullet1.background.fillOpacity = 0.8
        imageBullet1.background.strokeOpacity = 0
        imageBullet1.dy = -2
        imageBullet1.background.pointerBaseWidth = 10
        imageBullet1.background.pointerLength = 10
        imageBullet1.tooltipText = '{text}'

        series.tooltip.pointerOrientation = 'up'

        imageBullet1.background.adapter.add('pointerAngle', (value, target) => {
          if (target.dataItem) {
            let position = dateAxis.valueToPosition(target.dataItem.openDateX.getTime())
            return dateAxis.renderer.positionToAngle(position)
          }
          return value
        })

        let hs = imageBullet1.states.create('hover')
        hs.properties.scale = 1.3
        hs.properties.opacity = 1

        let textBullet = series.bullets.push(new am4charts.LabelBullet())
        textBullet.label.propertyFields.text = 'text'
        textBullet.disabled = true
        textBullet.propertyFields.disabled = 'textDisabled'
        textBullet.label.strokeOpacity = 0
        textBullet.locationX = 1
        textBullet.dy = -100
        textBullet.label.textAlign = 'middle'

        chart.scrollbarX = new am4core.Scrollbar()
        chart.scrollbarX.align = 'center'
        chart.scrollbarX.width = am4core.percent(75)
        chart.scrollbarX.parent = chart.curveContainer
        chart.scrollbarX.height = 300
        chart.scrollbarX.orientation = 'vertical'
        chart.scrollbarX.x = 128
        chart.scrollbarX.y = -140
        chart.scrollbarX.isMeasured = false
        chart.scrollbarX.opacity = 0.5

        let cursor = new am4plugins_timeline.CurveCursor()
        chart.cursor = cursor
        cursor.xAxis = dateAxis
        cursor.yAxis = categoryAxis
        cursor.lineY.disabled = true
        cursor.lineX.disabled = true

        dateAxis.renderer.tooltipLocation2 = 0
        categoryAxis.cursorTooltipEnabled = false

        chart.zoomOutButton.disabled = true

        let previousBullet

        chart.events.on('inited', function () {
          setTimeout(function () {
            this.hoverItem(series.dataItems.getIndex(0))
          }, 2000)
        })
      })
    },

    hoverItem (dataItem) {
      let bullet = dataItem.bullets.getKey(imageBullet1.uid)
      let index = dataItem.index

      if (index >= series.dataItems.length - 1) {
        index = -1
      }

      if (bullet) {
        if (previousBullet) {
          previousBullet.isHover = false
        }

        bullet.isHover = true

        previousBullet = bullet
      }
      setTimeout(
        function () {
          this.hoverItem(series.dataItems.getIndex(index + 1))
        }, 1000)
    },

    getPoints () {
      let points = [{ x: -1300, y: 200 }, { x: 0, y: 200 }]
      let w = 400
      let h = 400
      let levelCount = 4
      let radius = am4core.math.min(w / (levelCount - 1) / 2, h / 2)
      let startX = radius
      for (var i = 0; i < 25; i++) {
        let angle = 0 + i / 25 * 90
        let centerPoint = { y: 200 - radius, x: 0 }
        points.push({ y: centerPoint.y + radius * am4core.math.cos(angle), x: centerPoint.x + radius * am4core.math.sin(angle) })
      }
      for (var i = 0; i < levelCount; i++) {
        if (i % 2 != 0) {
          points.push({ y: -h / 2 + radius, x: startX + w / (levelCount - 1) * i })
          points.push({ y: h / 2 - radius, x: startX + w / (levelCount - 1) * i })

          let centerPoint = { y: h / 2 - radius, x: startX + w / (levelCount - 1) * (i + 0.5) }
          if (i < levelCount - 1) {
            for (var k = 0; k < 50; k++) {
              let angle = -90 + k / 50 * 180
              points.push({ y: centerPoint.y + radius * am4core.math.cos(angle), x: centerPoint.x + radius * am4core.math.sin(angle) })
            }
          }

          if (i == levelCount - 1) {
            points.pop()
            points.push({ y: -radius, x: startX + w / (levelCount - 1) * i })
            let centerPoint = { y: -radius, x: startX + w / (levelCount - 1) * (i + 0.5) }
            for (var k = 0; k < 25; k++) {
              let angle = -90 + k / 25 * 90
              points.push({ y: centerPoint.y + radius * am4core.math.cos(angle), x: centerPoint.x + radius * am4core.math.sin(angle) })
            }
            points.push({ y: 0, x: 1300 })
          }
        } else {
          points.push({ y: h / 2 - radius, x: startX + w / (levelCount - 1) * i })
          points.push({ y: -h / 2 + radius, x: startX + w / (levelCount - 1) * i })
          let centerPoint = { y: -h / 2 + radius, x: startX + w / (levelCount - 1) * (i + 0.5) }
          if (i < levelCount - 1) {
            for (var k = 0; k < 50; k++) {
              let angle = -90 - k / 50 * 180
              points.push({ y: centerPoint.y + radius * am4core.math.cos(angle), x: centerPoint.x + radius * am4core.math.sin(angle) })
            }
          }
        }
      }
      return points
    },
  },
}
</script>

<style lang='scss' scoped>

#grafico{
  max-height: 40rem;
  word-wrap: break-word;
}
.toggles{
  display: flex;
  direction: row;
  justify-content: space-between;
}

::v-deep  #chartjs-tooltip span{
  word-wrap: break-word;
}

#timelineSpan{
  font-size: 15px;
}

</style>
